module.exports = __webpack_public_path__ + "static/img/mjfPurpose4.cffc9a7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/mjfPurpose4.png
// module id = Kel+
// module chunks = 2